import React, { useRef, useState } from "react";
import { CSVLink } from "react-csv";
import { useDispatch } from "react-redux";
import { setAlert } from "../../../actions/alerts";

const DashboardExport = ({ reports }) => {
  const [exportData, setExportData] = useState([]);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const csvRef = useRef();

  // Function to format the aboveBenchmarkRange string from 20 to 30 into 20+
  function formatString(str) {
    return str.replace(/\s+to\s+\d+/, "+");
  }

  const prepareExport = async () => {
    setLoading(true);
    // Allow React to render loader first
    await new Promise((resolve) => setTimeout(resolve, 0));
    try {
      if (reports && reports.length > 0) {
        const formattedReports = reports.map((report) => ({
          ...report,
          CreatedDate: report.CreatedDate
            ? new Date(report.CreatedDate).toLocaleDateString("en-US", {
                year: "numeric",
                month: "short",
                day: "numeric",
              })
            : report.CreatedDate,
          aboveBenchmarkRange: formatString(report.aboveBenchmarkRange),
        }));
        setExportData(formattedReports);

        // Wait for CSVLink to receive updated data
        setTimeout(() => {
          try {
            csvRef.current.link.click();
          } catch (error) {
            dispatch(setAlert(error.message, "info"));
          } finally {
            setLoading(false);
          }
        }, 0);
      } else {
        throw new Error(
          "The data is still loading. Please try again in a few moments.",
        );
      }
    } catch (error) {
      dispatch(setAlert(error.message, "info"));
      console.error("Export failed:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <button
        className="btn button-parent button-primary text-center"
        onClick={!loading ? prepareExport : undefined}
        // style={{ minWidth: "140px" }}
        aria-disabled={loading}
      >
        {loading ? (
          <>
            <span
              className="spinner-border spinner-border-sm me-2"
              role="status"
              aria-hidden="true"
            />
            Preparing
          </>
        ) : (
          <>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              className="bi bi-download button-child m-0"
              viewBox="0 0 16 16"
            >
              <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z" />
              <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z" />
            </svg>
          </>
        )}
      </button>

      {/* Hidden CSV downloader */}
      {exportData.length > 0 && (
        <CSVLink
          ref={csvRef}
          data={exportData}
          filename="report.csv"
          style={{ display: "none" }}
        />
      )}
    </>
  );
};

export default DashboardExport;
